import entry from '@/page/entry'
import layout from '@/page/layout'
import login from '@/page/user/login'
import orderTackH5 from '@/page/orderTackH5'
import orderTackH5ForT from '@/page/orderTackH5ForT'

// 各个模块引入
// 【注意：各模块子页面，path、selectKeyUrl必须一致, name格式使用：'/模块路由名称/2级菜单路由名称'；子页面路由必须设置meta，包含字段openKeyName（1级菜单名称），selectKeyUrl（2级菜单路由名称）】
import shipOwnerAndShipCenterChildRoutes from '@/router/shipOwnerAndShipCenter'
import consignorCenterChildRoutes from '@/router/consignorCenter'
import palletsAndShipDatesChildRoutes from '@/router/palletsAndShipDates'
import orderCenterChildRoutes from '@/router/orderCenter'
import supervisionCenterChildRoutes from '@/router/supervisionCenter'
import projectCenterChildRoutes from '@/router/projectCenter'
import financialCenterChildRoutes from '@/router/financialCenter'

import systemPersonnelManagementChildRoutes from '@/router/systemPersonnelManagement'
import appManagementCenterChildRoutes from '@/router/appManagementCenter'
import riskControlCenterChildRoutes from '@/router/riskControlCenter'
import marketingCenterChildRoutes from '@/router/marketingCenter'
import landCenterChildRoutes from '@/router/landCenter'

const routes = [
  {
    path: '/',
    redirect: '/entry'
  },
  {
    path: '/login',
    component: login,
    beforeEnter (to, from, next) {
      next()
    }
  },
  {
    path: '/entry',
    component: entry,
    beforeEnter (to, from, next) {
      next()
    }
  },
  {
    path: '/orderTackH5/:id',
    component: orderTackH5,
    beforeEnter (to, from, next) {
      next()
    },
    props: true
  },
  {
    path: '/orderTackH5ForT/:id',
    component: orderTackH5ForT,
    beforeEnter (to, from, next) {
      next()
    },
    props: true
  },

  // 数据BI
  {
    path: '/dataBI',
    component: require('@/page/dataBI/index').default, // 不想单个文件引入
    name: 'dataBI/index'
  },
  // 项目数据大屏
  {
    path: '/dataScreen/:id',
    name: 'dataScreen',
    component: () => import('@/page/dataScreen/index'),
    // component: require('@/page/dataScreen/index').default, // 不想单个文件引入
    props: true,
  },
  // 船主及船舶中心
  {
    path: '/shipOwnerAndShipCenter',
    component: layout,
    beforeEnter (to, from, next) {
      next()
    },
    children: shipOwnerAndShipCenterChildRoutes
  },
  // 货主中心
  {
    path: '/consignorCenter',
    component: layout,
    beforeEnter (to, from, next) {
      next()
    },
    children: consignorCenterChildRoutes
  },
  // 货盘及船期
  {
    path: '/palletsAndShipDates',
    component: layout,
    beforeEnter (to, from, next) {
      next()
    },
    children: palletsAndShipDatesChildRoutes
  },
  // 订单中心
  {
    path: '/orderCenter',
    component: layout,
    beforeEnter (to, from, next) {
      next()
    },
    children: orderCenterChildRoutes
  },
  // 监管中心
  {
    path: '/supervisionCenter',
    component: layout,
    beforeEnter (to, from, next) {
      next()
    },
    children: supervisionCenterChildRoutes
  },
  // 财务中心
  {
    path: '/financialCenter',
    component: layout,
    beforeEnter (to, from, next) {
      next()
    },
    children: financialCenterChildRoutes
  },
  // 项目中心
  {
    path: '/projectCenter',
    component: layout,
    beforeEnter (to, from, next) {
      next()
    },
    children: projectCenterChildRoutes
  },
  // 系统管理 1
  {
    path: '/systemPersonnelManagement',
    component: layout,
    beforeEnter (to, from, next) {
      next()
    },
    children: systemPersonnelManagementChildRoutes
  },
  // 系统管理 2
  {
    path: '/appManagementCenter',
    component: layout,
    beforeEnter (to, from, next) {
      next()
    },
    children: appManagementCenterChildRoutes
  },
  // 1.5.0 风控中心
  {
    path: '/riskControlCenter',
    component: layout,
    beforeEnter (to, from, next) {
      next()
    },
    children: riskControlCenterChildRoutes
  },
  // 1.6.0 营销中心
  {
    path: '/marketingCenter',
    component: layout,
    beforeEnter (to, from, next) {
      next()
    },
    children: marketingCenterChildRoutes
  },
  // 2.0.0 陆运中心
  {
    path: '/landCenter',
    component: layout,
    beforeEnter (to, from, next) {
      next()
    },
    children: landCenterChildRoutes
  },
  {
    // 此处必须写在正常route最后
    path: '*',
    component: () => import('@/page/404')
  }
]

export default {
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js